import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

import { ParentComponent } from '@app/shared/constants/parent-component';
import { MonthlyReportService } from '@app/monthly-report/services/monthly-report.service';
import { TimesheetService } from '@app/timesheet-user/services/timesheet.service';
import { AbstractSubscriptionManager } from '@app/shared/classes/subscription-manager';
import { MessageService } from '@app/services/message.service';
import { ErrorMessage } from '@app/constants/messages.constants';

import { ExportType } from './export-box.constants';

@Component({
  selector: 'app-export-box',
  templateUrl: './export-box.component.html',
  styleUrls: ['./export-box.component.scss']
})
export class ExportBoxComponent extends AbstractSubscriptionManager {
  @Input() parentComponent: ParentComponent;

  constructor(
    private _monthlyReportService: MonthlyReportService,
    private _timesheetService: TimesheetService,
    private _messageService: MessageService
  ) {
    super();
  }

  onPdfExport(): void {
    this.subscription.add(
      this._handleExportAction(ExportType.Pdf).subscribe({
        error: (err) => {
          this._messageService.showErrorMessage(ErrorMessage.General);
        }
      })
    );
  }

  onExcelExport(): void {
    this.subscription.add(
      this._handleExportAction(ExportType.Excel).subscribe({
        error: (err) => {
          this._messageService.showErrorMessage(ErrorMessage.General);
        }
      })
    );
  }

  private _handleExportAction(format: ExportType): Observable<HttpResponse<Blob>> {
    switch (this.parentComponent) {
      case ParentComponent.MonthlyReport:
        return this._monthlyReportService.exportReport(format);
      case ParentComponent.Timesheet:
        return this._timesheetService.exportTimesheet(format);
    }
  }
}
